(function(){
  function formatCurrency(cents, currency){
    try{
      return (cents/100).toLocaleString('es-MX', {
        style: 'currency', currency: currency || 'MXN', maximumFractionDigits: 0
      });
    }catch(e){
      return '$' + Math.round(cents/100).toLocaleString('es-MX');
    }
  }

  function computeMonthlyCents(priceCents, deposit, annual, term){
    priceCents = Number(priceCents) || 0;
    if(priceCents <= 0) return 0;
    var P     = priceCents / 100;          // precio MXN
    var saldo = P * (1 - (Number(deposit) || 0.20));
    var i     = (Number(annual) || 0.20) / 12;
    var n     = Number(term) || 36;
    var cuota = (saldo * i) / (1 - Math.pow(1 + i, -n));
    return Math.max(1, Math.round(cuota * 100));
  }

  function initOne(root){
    if(!root || root.__monthlySimInitialized) return;
    root.__monthlySimInitialized = true;

    var priceCents = root.getAttribute('data-price-cents');
    var currency   = root.getAttribute('data-currency') || 'MXN';
    var deposit    = root.getAttribute('data-deposit')  || 0.20;
    var annual     = root.getAttribute('data-annual')   || 0.20;
    var term       = root.getAttribute('data-term')     || 36;
    var valueEl    = root.querySelector('.monthly-sim__value');

    function render(cents){
      var m = computeMonthlyCents(cents, deposit, annual, term);
      if(valueEl) valueEl.textContent = m ? formatCurrency(m, currency) : '$—';
    }

    // Render inicial con el precio del data-attr
    render(priceCents);

    // Si estamos en PDP y cambian variantes, actualizamos.
    document.addEventListener('variant:change', function(e){
      if(!root.closest('form')) return; // solo la PDP propia
      var v = e && e.detail && e.detail.variant;
      if(v && typeof v.price === 'number') render(v.price);
    });
  }

  function initAll(){
    document.querySelectorAll('.monthly-sim').forEach(initOne);
  }

  // Hooks para contenido dinámico:
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('product-recommendations:updated', initAll);

  // Fallback genérico ante inserciones dinámicas
  var mo = new MutationObserver(function(){
    initAll();
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();
